import Gap from '~/components/Gap';
import Text from '~/components/Text';
import ClientContextMenu from '../CellContent/ClientContextMenu';
import { useClientListContext } from '../hooks/useClientListContext';
import * as Styles from './styles';

const ClientList = () => {
  const { listIds, listData } = useClientListContext();
  return (
    <div>
      <ul>
        {listIds.map(clientId => {
          const thisClientData = listData[clientId];
          const countryCode = thisClientData.country_code
            ? thisClientData.country_code.split(' ')[0]
            : '';

          return (
            <Styles.ListItem key={clientId}>
              <Styles.LeftContainer>
                <Text size="xsmd" className="bold">
                  {thisClientData.company_name}
                </Text>
                <Gap t={2} />
                <Text size="xsmd" variant="secondary">
                  {thisClientData.email}
                </Text>
                <div>
                  <Text size="xsmd" variant="secondary">
                    {thisClientData.phone ? `${countryCode} ${thisClientData.phone}` : '--'}
                  </Text>
                </div>
              </Styles.LeftContainer>

              <Styles.RightContainer>
                <div className="d-flex v-center">
                  <ClientContextMenu clientReferenceId={clientId} />
                </div>
              </Styles.RightContainer>
            </Styles.ListItem>
          );
        })}
      </ul>
    </div>
  );
};

export default ClientList;
